import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';
import { TipoTitulo, TituloProceso } from '@app/shared';

@Injectable()
export class ManageTitlesDataService {
  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private api: EndpointService,
  ) {}

  /**
   * Consulta los tipos de titulos del sistema en el proceso
   *
   * @returns {Observable<TipoTitulo[]>}
   * @memberof ManageTitlesDataService
   */
  getTitles(): Observable<TipoTitulo[]> {
    return new Observable(obs => {
      this.http.get<TipoTitulo[]>(this.api.get('titles')).subscribe(
        titles => {
          obs.next(titles);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   * Consulta las observaciones de un expediente
   *
   * @returns {Observable<TituloProceso[]>}
   * @memberof ManageTitlesDataService
   */
  getTitlesProcess(process: number): Observable<TituloProceso[]> {
    return new Observable(obs => {
      this.http.get<TituloProceso[]>(this.api.get('processTitles', [process])).subscribe(
        titles => {
          if (titles.length) {
            titles.map((title) => {
              title.titulo_texto = title.tipo_titulo.nombre;
            });
          }
          obs.next(titles);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   * Agrega una observación a un expediente
   *
   * @param {number} process
   * @param {number} title
   * @param {string} value
   * @returns {Promise<boolean>}
   * @memberof ManageTitlesDataService
   */
  addTitleProcess(process: number, title: number, value: string): Promise<boolean> {
    let configData: any;
    configData = {
      tramite: process,
      tipo_titulo: title,
      valor: value
    };
    return new Promise((resolve, reject) => {
      this.http
        .post(this.api.get('processTitles'), configData)
        .subscribe(
          _res => {
            resolve(true);
            this.toastr.success('Título agregado correctamente.', 'Operación exitosa');
          },
          err => {
            reject(err);
          }
        );
    });
  }

  /**
   * Actualiza la observacion de un expediente
   *
   * @param {number} idTitle
   * @param {number} process
   * @param {number} title
   * @param {string} value
   * @returns {Promise<boolean>}
   * @memberof ManageTitlesDataService
   */
  updateTitleProcess(idTitle: number, process: number, title: number, value: string): Promise<boolean> {
    let configData: any;
    configData = {
      tramite: process,
      tipo_titulo: title,
      valor: value
    };
    return new Promise((resolve, reject) => {
      this.http
        .put(this.api.get('processTitles', [idTitle]), configData)
        .subscribe(
          _res => {
            resolve(true);
            this.toastr.success('Título modificado correctamente.', 'Operación exitosa');
          },
          err => {
            reject(err);
          }
        );
    });
  }

  /**
   * Elimina la observacion de un expediente
   *
   * @param {number} idTitle
   * @returns {Observable<boolean>}
   * @memberof ManageTitlesDataService
   */
  deleteTitleProcess(idTitle: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http
        .delete(this.api.get('processTitles', [idTitle]))
        .subscribe(
          _res => {
            resolve(true);
            this.toastr.success('Título eliminado correctamente.', 'Operación exitosa');
          },
          err => {
            reject(err);
          }
        );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/basic-process-configuration/manage-titles/shared/manage-titles.data.service.ts